import React from "react";
import hydrate from "next-mdx-remote/hydrate";
import Layout from "components/Docs/Layout";
import MDX from "components/MDX";
import { useRouter } from "next/router";
import DetailLoader from "components/DetailLoader";
import isEmpty from "lodash/isEmpty";
import SlimCTA from "components/SlimCTA";

const Post = ({ post, navConfig }) => {
  const router = useRouter();
  if (router.isFallback) {
    return <DetailLoader />;
  }

  /**
   * Pass more props to scope which we have prepared on the client
   */
  const { mdxSource, frontMatter } = post;
  let content;
  if (isEmpty(mdxSource)) {
    content = (
      <div className="w-100 h-100 center flex items-center justify-center pa3">
        <div className="mw8">
          <SlimCTA
            header="No content available"
            subheader="This is likely an error, sorry about that. Please refresh or try another page."
          />
        </div>
      </div>
    );
  } else {
    mdxSource.scope = {
      ...mdxSource.scope,
      navConfig
    };
    content = hydrate(mdxSource, {
      components: MDX
    });
  }

  return (
    <Layout key={router.asPath} navConfig={navConfig} frontMatter={frontMatter}>
      {content}
    </Layout>
  );
};

export default Post;
